import { render, staticRenderFns } from "./DifNavisionNavixy.vue?vue&type=template&id=0fc1694b&scoped=true&"
import script from "./DifNavisionNavixy.vue?vue&type=script&lang=js&"
export * from "./DifNavisionNavixy.vue?vue&type=script&lang=js&"
import style0 from "./DifNavisionNavixy.vue?vue&type=style&index=0&id=0fc1694b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc1694b",
  null
  
)

export default component.exports